// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Spinner_wrapper__18-WQ","fadein":"Spinner_fadein__36Leq","spinner":"Spinner_spinner__a7dIv","spin":"Spinner_spin__1e3cZ"};